import { Backdrop, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppState } from '../store';
/**
 * An overlay with a loading circle which is displayed if there is some background task running
 * @returns {JSX.Element} the overlay with the loading circle component
 */
export const LoadingScreen = () => {
  const { t } = useTranslation();

  //selectors
  const busy = useSelector((state: AppState) => state.busy);
  const configuration = useSelector((state: AppState) => state.configuration);

  return (
    <Backdrop open={busy}>
      <>
        <CircularProgress /> &nbsp;
        {configuration?.loaderMessage
          ? t('loaderMessage.' + configuration.loaderMessage)
          : t('loaderMessage.default')}
        ...
      </>
    </Backdrop>
  );
};
